import React, { useEffect, useState, useMemo , useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useToast } from "../context/ToastContext";
import { verifyEmail } from "../services/authService.ts";
import leftbgimg from "../assets/leftbg.jpg";
import bgimg from "../assets/loginbg.png";
import { CheckCircle, XCircle, Loader2 } from "lucide-react"; // icons from lucide-react

const VerifyEmail = () => {
  const { showSuccess, showError } = useToast();
  const navigate = useNavigate();
  const location = useLocation();
  const [status, setStatus] = useState("verifying"); // verifying, success, error
  const [message, setMessage] = useState("");

  const { token, uid, slug } = useMemo(() => {
    const qs = new URLSearchParams(location.search);
    return {
      token: qs.get("token") || "",
      uid: qs.get("uid") || "",
      slug: qs.get("slug") || "",
    };
  }, [location.search]);

const hasCalled = useRef(false);

useEffect(() => {
     // ✅ Clear any previous auth info immediately on mount
    localStorage.removeItem("authUser");
    localStorage.removeItem("authToken");
  if (hasCalled.current) return;
  hasCalled.current = true;

  const run = async () => {
    if (!token || !uid) {
      setStatus("error");
      setMessage("Verification link is invalid or missing parameters.");
      return;
    }

    setStatus("verifying");
    setMessage("");

    try {
      const res = await verifyEmail(token, uid, slug);
      console.log("VERIFY email RESPONSE:", res);

      if (res?.success) {
        setStatus("success");
        setMessage(res.message || "Email verified successfully!");
      } else {
        // Handle backend 400/401/expired token messages
        setStatus("error");
        setMessage(res?.error || res?.message || "Failed to verify email.");
      }
    } catch (err) {
    console.error("Error during email verification:", err);
    setStatus("error");

    const msg = err?.error || err?.message || "Unable to verify email due to network error.";
    setMessage(msg);
}
    };
  
  run();
}, [token]);

// useEffect(() => {
//   const run = async () => {
//     if (!token) {
//       setStatus("error");
//       setMessage("Verification link is invalid.");
//       return;
//     }

//     setStatus("verifying");

//     try {
//       const res = await verifyEmail(token, uid, slug); // res = { success: true, message: "..." }
// console.log("VERIFY email RESPONSE:", res);
//       if (res?.success) {
//         setStatus("success");
//         setMessage(res.message);
//       } else {
//         setStatus("error");
//         setMessage(res?.message || "Unable to verify email.");
//       }
//     } catch (err) {
//       const data = err?.response?.data;
//       const msg =
//         (typeof data === "string" && data) ||
//         data?.message ||
//         data?.error ||
//         "Unable to verify email.";
//       setStatus("error");
//       setMessage(msg);
//     }
//   };

//   run();
// }, [token]);






//   useEffect(() => {
//     const run = async () => {
//       if (!token) {
//         setStatus("error");
//         setMessage("Verification link is invalid.");
//         return;
//       }

//       setStatus("verifying");
//       try {
//         const res = await verifyEmail(token);
//         console.log("VERIFY email RESPONSE:", res);
//       if (res?.data?.success) {
//   setStatus("success");
//   setMessage(res.data.message);
//         } else {
//           setStatus("error");
//           setMessage(res?.message || "Unable to verify email.");
//         }
//       } catch (err) {
//         const data = err?.response?.data;
//         const msg =
//           (typeof data === "string" && data) ||
//           data?.message ||
//           data?.error ||
//           "Unable to verify email.";
//         setStatus("error");
//         setMessage(msg);
//       }
//     };
//     run();
//   }, [token]);

 const handleLogin = () => {
  localStorage.removeItem("authUser");  
  localStorage.removeItem("authToken");  
  navigate("/login");
};

  return (
  <div className="min-h-screen w-full flex items-center justify-center">
  <div className="flex flex-col items-center justify-center w-full max-w-lg shadow-xl p-8 text-center">
    
    {status === "verifying" && (
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="animate-spin text-blue-600 w-16 h-16" />
        <p className="text-white/80 text-lg md:text-xl">
          Verifying your email...
        </p>
      </div>
    )}

    {status === "success" && (
      <div className="flex flex-col items-center gap-6">
        <div className="bg-green-600 rounded-full p-6">
          <CheckCircle className="w-16 h-16 text-white" />
        </div>

        <h2 className="text-3xl font-bold text-white">
          Email Verified!
        </h2>

        <p className="text-white/80 max-w-md">
          {message}
        </p>

        <button
          onClick={handleLogin}
          className="mt-4 px-8 py-3 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 transition"
        >
          Proceed to Login
        </button>
      </div>
    )}

    {status === "error" && (
      <div className="flex flex-col items-center gap-6">
        <div className="bg-red-600 rounded-full p-6">
          <XCircle className="w-16 h-16 text-white" />
        </div>

        <h2 className="text-3xl font-bold text-white">
          Verification Failed
        </h2>

        <p className="text-white/80 max-w-md">
          {message}
        </p>

        <button
          onClick={handleLogin}
          className="mt-4 px-8 py-3 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 transition"
        >
          Go to Login
        </button>
      </div>
    )}

  </div>
</div>
  );
}

export default VerifyEmail;
